const Severity = {
  MINOR: 'minor',
  MAJOR: 'major',
  CRITICAL: 'critical',
};
export default Severity;
